import { Component, OnInit } from "@angular/core";
import { DataService } from "../../../../src/app/shared/services/data.service";
import { LoaderService } from "../../../../src/app/shared/services/loader/loader.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationComponent } from "../../../../src/app/shared/dialogs/confirmation/confirmation.component";
import { DifficultyLevelComponent } from "../../../../src/app/shared/dialogs/difficulty-level/difficulty-level.component";
import { ShowMovieComponent } from "../../../../src/app/shared/dialogs/show-movie/show-movie.component";
import { ImageModalComponent } from "../../../../src/app/shared/dialogs/image-modal/image-modal.component";
import { LanguageService } from "../../../../src/app/shared/services/language/language.service";
import { ResponseData } from "../../shared/services/teacher.interface";

export interface ResponseType<T> {
  code: number;
  detail: string;
  data: T;
  success: boolean;
}

export interface QuestionStatus {
  total_questions: number;
  answered_questions: number;
  maximum_score: number;
  score: number;
  score_percentage: number;
  attempted_percentage: number | string;
  difficulty_count: DifficultyCount;
  completed_dfficulty: CompletedDfficulty;
  badge: string;
}

interface CompletedDfficulty {
  easy: boolean;
  medium: boolean;
  hard: boolean;
}

export interface DifficultyCount {
  all: number;
  easy: number;
  medium: number;
  hard: number;
}

export interface Sdg {
  id: string
  name: string
  image: string
  name_en_us: string
  name_nl: string
}

export interface QuestionDetails {
  id: string;
  correct_option: string;
  options: QuestionOptions[];
  sdg: Sdg;
  country: string;
  topic: any;
  attempted: boolean;
  is_right: boolean;
  selected_option: any;
  updated_on: string;
  created_on: string;
  title: string;
  title_nl: string;
  title_en_us: string;
  question_number: number;
  image: any;
  image_nl: any;
  image_en_us: any;
  videoImage: string;
  video_link: string;
  video_link_nl: string;
  video_link_en_us: string;
  media_type: number;
  hint: string;
  hint_nl: string;
  hint_en_us: string;
  feedback: string;
  feedback_nl: string;
  feedback_en_us: string;
  info_link: string;
  info_link_nl: string;
  info_link_en_us: string;
  is_active: boolean;
  difficulty: number;
  published_date: string;
  creator: any;
  updater: any;
}

export interface QuestionOptions {
  id: string;
  question: string;
  option: string;
  updated_on: string;
  created_on: string;
  description: string;
  description_nl: string;
  description_en_us: string;
  creator: any;
  updater: any;
}

export interface ResultData<T> {
  count: number
  next: any
  previous: any
  results: T[]
}

export interface UnQnList{
  id: string;
  title: string;
  difficulty: number;
  score: number;
  total_score: number;
  attempted: boolean;
  is_right: boolean;
}

@Component({
  selector: "app-question",
  templateUrl: "./question.component.html",
  styleUrls: ["./question.component.scss"],
})
export class QuestionComponent implements OnInit {
  allCountries : any = [];
  lstCountries : any = [];
  // lstCountries = [{ id: '0', name: 'All countries', image:'assets/icons/all-countries.svg' }];
  selectedCountry = "All countries";
  selectedCountryId = "0";
  sdgId: any;
  back: boolean | undefined;
  questionStatus: QuestionStatus;
  unAttendedQuestions : UnQnList[];
  totalQuestionCount: number = 0;
  totalAnswerCount: number = 0;
  totalQAPercentage: number = 0;
  questionId: string = "";
  questionDetails: QuestionDetails | null;
  correctOption: QuestionOptions;
  alphaIndex = ["A", "B", "C", "D", "E"];
  startTime: number;
  selectedOption: any;
  answerSubmitted: boolean = false;
  upComingBadge = "";
  // pointNeed = 0;
  difficultyLevel: number = 1;
  SdgFlow: boolean = false;
  badgeEarnedAnimation: boolean = false;
  topicCompleted: boolean = false;
  noQuestionsFound: boolean = false;
  noQuestonSubMessage: boolean = false;
  completedLevel: string = "";

  bronzeEarned = 0;
  SilverEarned = 0;
  GoldEarned = 0;
  isSmallScreen = false;

  selectedLang: any = localStorage.getItem("userLang") == "en" ? "en_us" : "nl";

  // statusParams = {
  //   sdg: 0,
  //   country: 0,
  //   subject: 0,
  //   difficulty: '',
  //   offset: 0
  // }
  unansweredParams = {
    limit: "",
    offset: 0,
    sdg: "",
    country: "",
    topic: "",
    difficulty: 1,
  };

  questionParams = {
    sdg: "",
    country: "",
    subject: "",
    difficulty: 1,
    category: "",
    offset: 0,
  };
  sdgOptionList = [];

  correctAnswer = 0;
  wrongAnswer = 0;
  questionScore: any;

  // questionDetails:any = responseData.data;

  constructor(
    private languageService: LanguageService,
    public dialog: MatDialog,
    public loaderService: LoaderService,
    public serviceData: DataService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.languageService.translateLanguge.subscribe((value) => {
      this.selectedLang = value == "en" ? "en_us" : "nl";
    });
    // const navigation = this.router.getCurrentNavigation();
    this.activatedRoute.queryParams.subscribe((params) => {
      console.log("location changes");
      this.sdgId = params["id"];
      this.SdgFlow = this.sdgId != "0" ? true : false;
      this.back = params["back"] === "true";
      this.selectedCountryId = params["country"] || "0";
      this.difficultyLevel = params["level"] || 1; // 1 = Easy, 3 - Hard
      this.questionParams.category = this.sdgId;
      this.questionParams.difficulty = this.difficultyLevel;
      this.questionParams.country = this.selectedCountryId;
      this.getQuestionStatus();
    });
    this.getSdgBannerList();
    this.loadVideoCountryList();
  }

  getSdgBannerList() {
    this.loaderService.display(true);
    this.serviceData.getCategoryPublicFilter().subscribe({
      next: (resp: any) => {
        this.sdgOptionList = resp.data.results;
        this.loaderService.display(false);
      },
      error: (err) => {
        this.loaderService.display(false);
        console.error(err);
      },
    });
  }

  getTranslation(source: any, property: any) {
    return source ? source[`${property}_${this.selectedLang}`] : "";
  }

  // get video country list api
  loadVideoCountryList() {
    let params = {
      is_question: "True", //filtering the the countries that has atleast one question
      difficulty: this.difficultyLevel,
    };
    // this.loaderService.display(true);
    this.serviceData.getCountryFilter(params).subscribe(
      (resp: any) => {
        // this.loaderService.display(false);
        if (resp.success) {
          // this.allCountries = resp.data.results;
          let countries = resp.data.results.map(
            (country: { name: string; id: string; flag: string }) => {
              return {
                ...country,
                image: country.flag, // rename `flag` to `image`
              };
            }
          );
          this.lstCountries.push(...countries);
        }
      },
      (Error) => {
        console.log("Err is ", Error);
        this.loaderService.display(false);
      }
    );
  }

  getQuestionStatus() {
    this.selectedOption = "";
    this.loaderService.display(true);
    this.serviceData.getQuestionStatus(this.questionParams).subscribe({
      next: (status: ResponseType<QuestionStatus>) => {
        this.questionStatus = status.data;
        this.noQuestonSubMessage = false;
        // either hard or easy questions remains
        if (
          this.questionStatus.completed_dfficulty.easy == false ||
          this.questionStatus.completed_dfficulty.hard == false
        ) {
          this.getUnansweredQuestions();
        } else {
          //No questions for this filter
          if (this.questionStatus.difficulty_count.all == 0) {
            this.questionDetails = null;
            this.noQuestionsFound = true;
            this.loaderService.display(false);
          } else {
            // all questions answered
            this.questionDetails = null;
            this.noQuestionsFound = true;
            this.noQuestonSubMessage = true;
            this.loaderService.display(false);
            // this.confirmQuit(true);
          }
        }
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
        this.loaderService.display(false);
      },
    });
  }

  getUnansweredQuestions() {
    this.loaderService.display(true);
    this.serviceData.getUnansweredQuestionList(this.questionParams).subscribe({
      next: (res:ResponseType<ResultData<UnQnList>>) => {
        console.log(res);
        this.totalAnswerCount = 0;
        // this.unAttendedQuestions.push(...res['data']['results'])
        this.unAttendedQuestions = res.data.results;
        this.unAttendedQuestions = res["data"]["results"];
        this.totalQuestionCount = res["data"]["count"];

        if (this.unAttendedQuestions.length != 0) {
          this.completedLevel = "";
          this.getQuestion(this.unAttendedQuestions[0].id);
          this.noQuestionsFound = false;
        } else {
          //if no questions
          this.completedLevel =
            this.questionStatus.completed_dfficulty.easy == true
              ? "Easy"
              : "Hard";
          this.questionDetails = null;
          this.noQuestionsFound = true;
          this.loaderService.display(false);
          // this.router.navigateByUrl('/topic-completed')
        }
      },
      error: (err: HttpErrorResponse) => {
        this.loaderService.display(false);
        console.log(err);
      },
    });
  }

  getQuestion(id: string) {
    this.questionId = id;
    this.checkTopicCompleted();
    // this.loaderService.isShowDialog
    this.loaderService.display(true);
    let params = {
      id,
      country: this.questionParams.country,
      difficulty: this.questionParams.difficulty,
      category: this.questionParams.category,
    };
    this.serviceData.getModalQuestion(params).subscribe({
      next: (res: ResponseType<QuestionDetails>) => {
        this.questionDetails = null;
        this.questionDetails = res.data;
        // generating correct options object
        this.questionDetails.options.forEach((qstn, index) => {
          if (qstn.id == this.questionDetails?.correct_option) {
            this.correctOption = qstn;
            this.correctOption.option = this.alphaIndex[index];
          }
        });
        // answer loaded time
        this.startTime = Date.now();
        // if video exist
        if (this.questionDetails?.media_type == 3) {
          // let vt = this.questionDetails.video_link.split('?');
          // this.questionDetails.videoImage = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
          // //i.ytimg.com/vi/VWgQ07_BpOg/hqdefault.jpg
          let vt = this.questionDetails?.video_link?.split("/")?.pop()?.split(" ") || [];
          this.questionDetails.videoImage =
            "//i.ytimg.com/vi/" + vt[0] + "/hqdefault.jpg";
        }
        this.loaderService.display(false);
        setTimeout(() => {}, 5000);
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
        this.loaderService.display(false);
      },
    });
  }

  // answerSelected(x,y,z){
  //   this.answerSubmitted = true;
  //   console.log(this.correctOption)
  //   console.log(this.selectedOption);
  // }

  get filteredOptions() {
    if (!this.answerSubmitted) {
      return this.questionDetails?.options || [];
    } else {
      // After submission, only display the correct option and selected (incorrect) option
      return this.questionDetails?.options.filter(
        (item) =>
          item.id === this.questionDetails?.correct_option ||
          item === this.selectedOption
      );
    }
  }

  answerClicked(item, option, questionId) {
    // if (!this.isAnswerClicked) {
    // this.isAnswerClicked = true;
    // this.everAttented = true;

    this.loaderService.display(true);
    this.serviceData.showMouseLoader();

    // this.questionScore = 0;
    this.selectedOption = item;
    this.selectedOption.option = option;

    let data = {
      selected_option: item.id,
      duration: Math.floor((Date.now() - this.startTime) / 1000),
    };

    this.serviceData.markAnswer(this.questionId, data).subscribe(
      (resp: any) => {
        console.log(resp);
        // this.isAnswerClicked = false;
        if (resp.success) {
          // this.showQuestion = false;
          this.answerSubmitted = true;
          if (
            this.questionDetails?.media_type == 3 ||
            this.questionDetails?.media_type == 2
          ) {
            this.questionDetails.media_type = 1;
          }
          this.questionDetails?.options.filter(
            (item) =>
              item.id === this.questionDetails?.correct_option ||
              item === this.selectedOption
          );
          if (item.id == this.questionDetails?.correct_option) {
            this.correctAnswer = 1;
            this.questionStatus.score =
              this.questionStatus.score + resp.data.score;
            this.questionScore = resp.data.score;
            this.questionStatus.answered_questions =
              this.questionStatus.answered_questions + 1;
            setTimeout(() => {
              this.correctAnswer = 2;
            }, 3000);
          } else {
            this.questionStatus.answered_questions =
              this.questionStatus.answered_questions + 1;
            this.wrongAnswer = 1;

            setTimeout(() => {
              this.wrongAnswer = 2;
            }, 4000);
          }

          this.checkStatus();

          // check if topic(category questions) completed or not
          this.checkTopicCompleted();
          // this.questionStatus.attempted_percentage = Number(((this.questionStatus.answered_questions / this.questionStatus.total_questions) * 100).toFixed(2));
          // // if topic completed
          // if(this.questionStatus.attempted_percentage >= 100){
          //   this.topicCompleted = true
          // }
          let score_percentage = (
            (this.questionStatus.score / this.questionStatus.maximum_score) *
            100
          ).toFixed(2);
          // console.log(score_percentage);

          this.questionStatus.score_percentage = Number(
            (
              (this.questionStatus.score / this.questionStatus.maximum_score) *
              100
            ).toFixed(2)
          );
          // console.log(this.questionStatus.attempted_percentage, this.questionStatus.score_percentage)
          // if (this.questionStatus.score_percentage < 20) {
          //   this.questionStatus.badge = 'None';
          //   // this.upComingBadge = 'Bronze';
          //   // let x = Math.ceil(((20 * this.questionStatus.maximum_score) / 100) - this.questionStatus.score);
          //   // this.pointNeed = x;
          // } else if (this.questionStatus.score_percentage >= 20 && this.questionStatus.score_percentage < 50) {
          //   if(this.questionStatus.badge != 'Bronze'){
          //     this.questionStatus.badge = 'Bronze';
          //     this.showBadgeEarnedAnimation()
          //   }
          //   // this.upComingBadge = 'Silver';
          //   // let x = Math.ceil(((50 * this.questionStatus.maximum_score) / 100) - this.questionStatus.score);
          //   // this.pointNeed = x;
          // } else if (this.questionStatus.score_percentage >= 50 && this.questionStatus.score_percentage < 80) {
          //   if(this.questionStatus.badge != 'Silver'){
          //     this.questionStatus.badge = 'Silver';
          //     this.showBadgeEarnedAnimation()
          //   }
          //   // this.upComingBadge = 'Gold';
          //   // let x = Math.ceil(((80 * this.questionStatus.maximum_score) / 100) - this.questionStatus.score);
          //   // this.pointNeed = x;
          // } else {
          //   if(this.questionStatus.badge != 'Gold'){
          //     this.questionStatus.badge = 'Gold';
          //     this.showBadgeEarnedAnimation()
          //   }
          // }
          // console.log(this.questionStatus.badge);
          if (this.unAttendedQuestions.length > 1) {
            this.unAttendedQuestions.every((qstn: any, index) => {
              if (qstn.id == questionId) {
                if (index == this.unAttendedQuestions.length - 1) {
                  this.questionId = this.unAttendedQuestions[0].id;
                  return false;
                } else {
                  this.questionId = this.unAttendedQuestions[index + 1].id;
                  this.repopulateQuestionList(index);
                  return false;
                }
              } else {
                return true;
              }
            });
          }
          this.unAttendedQuestions.forEach((qstn, index) => {
            if (qstn.id == questionId) {
              this.unAttendedQuestions.splice(index, 1);
            }
          });
          // console.log(this.unattendedQuestionsList);
        }
        this.loaderService.display(false);
        this.serviceData.hideMouseLoader();
      },
      (Error) => {
        this.loaderService.display(false);
        this.serviceData.hideMouseLoader();
        console.log("Err is ", Error);
      }
    );
    // }
  }

  checkStatus() {
    this.serviceData.getQuestionStatus(this.questionParams).subscribe({
      next: (status: ResponseType<QuestionStatus>) => {
        if (status.data.badge == "None") {
          this.questionStatus.badge = "None";
          this.questionStatus = status.data;
        } else if (status.data.badge == "Bronze") {
          if (this.questionStatus.badge != "Bronze") {
            this.questionStatus.badge = "Bronze";
            this.showBadgeEarnedAnimation(status.data);
          }
        } else if (status.data.badge == "Silver") {
          if (this.questionStatus.badge != "Silver") {
            this.questionStatus.badge = "Silver";
            this.showBadgeEarnedAnimation(status.data);
          }
        } else {
          if (this.questionStatus.badge != "Gold") {
            this.questionStatus.badge = "Gold";
            this.showBadgeEarnedAnimation(status.data);
          }
        }

        // this.getUnansweredQuestions()
        // let nextLevel = false;
        // if(this.difficultyLevel == 1){
        //   nextLevel = status.data.completed_dfficulty.easy == true && status.data.completed_dfficulty.hard == false
        // }else{
        //   nextLevel = status.data.completed_dfficulty.hard == true && status.data.completed_dfficulty.easy == false
        // }
        // if(nextLevel){
        //   const dialogRef = this.dialog.open(DifficultyLevelComponent, {
        //     disableClose: true,
        //     data:{id: this.sdgId != '0' ? this.sdgId : this.questionParams.country,
        //        category: this.sdgId != '0' ? true : false,
        //        same_route: true}
        //   });
        //   dialogRef.afterClosed().subscribe((data)=>{
        //     if(data){
        //       let level = data == 'HARD' ? 3 : 1;
        //       this.router.navigate(['/question'], {
        //         relativeTo: this.activatedRoute,
        //         queryParams: { id : this.sdgId != '0' ? this.sdgId : '0',
        //           back: true,
        //           country : this.sdgId == '0' ? this.questionParams.country : '0',
        //           level },
        //         queryParamsHandling: null // Merges with the existing query parameters
        //       });

        //     }
        //   })
        // }
        // if(status.data.completed_dfficulty.easy == true && status.data.completed_dfficulty.hard == true){
        //   console.log(this.sdgId,this.selectedCountry,this.questionParams.country);

        //   let params = { id: this.sdgId != '0' ? this.sdgId : this.questionParams.country, category: this.sdgId != '0' ? true : false}
        //   this.router.navigate(['/topic-completed'],{queryParams : params})
        // }
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
      },
    });
  }

  checkTopicCompleted() {
    this.questionStatus.attempted_percentage = Number(
      (
        (this.questionStatus.answered_questions /
          this.questionStatus.total_questions) *
        100
      ).toFixed(2)
    );
    // this.totalQAPercentage = Number(((this.totalAnswerCount / this.totalQuestionCount) * 100).toFixed(2));
    // if topic completed
    console.log(typeof this.sdgId, this.sdgId);

    // if(this.questionStatus.attempted_percentage >= 100){
    //   // this.router.navigateByUrl('/topic-completed')
    //   let params = { id: this.sdgId != '0' ? this.sdgId : this.selectedCountryId, category: this.sdgId != '0' ? true : false}
    //   this.router.navigate(['/topic-completed'],{queryParams : params})
    // }
    // if(this.totalAnswerCount == this.totalQuestionCount){
    //   this.router.navigateByUrl('/topic-completed')
    // }
  }

  showBadgeEarnedAnimation(data: QuestionStatus) {
    this.badgeEarnedAnimation = true;
    setTimeout(() => {
      this.questionStatus = data;
      this.badgeEarnedAnimation = false;
    }, 5000);
  }

  repopulateQuestionList(index) {
    if (
      this.unAttendedQuestions.length - index == 3 &&
      this.totalQuestionCount > this.unAttendedQuestions.length
    ) {
      // this.questionParams.offset = this.unattendedQuestionsList.length - 1;
      // this.questionParams.offset = this.unAttendedQuestions.length;
      this.serviceData.getUnansweredQuestionList(this.questionParams).subscribe(
        (resp: any) => {
          if (resp.success) {
            this.unAttendedQuestions.push(...resp.data.results);
            // console.log(this.unAttendedQuestions);
          }
        },
        (Error) => {
          console.log(Error);
        }
      );
    }
  }

  continueNextQuestion() {
    this.questionDetails = null;
    this.answerSubmitted = false;
    this.correctAnswer = 0;
    this.wrongAnswer = 0;
    this.selectedOption = "";
    // this.getQuestionDetails();
    // console.log(this.unAttendedQuestions);
    this.serviceData.getQuestionStatus(this.questionParams).subscribe({
      next: (status: ResponseType<QuestionStatus>) => {
        this.questionStatus = status.data;
        // this.getUnansweredQuestions()
        let nextLevel = false;
        if (this.difficultyLevel == 1) {
          nextLevel =
            status.data.completed_dfficulty.easy == true &&
            status.data.completed_dfficulty.hard == false;
        } else {
          nextLevel =
            status.data.completed_dfficulty.hard == true &&
            status.data.completed_dfficulty.easy == false;
        }
        if (nextLevel) {
          this.questionDetails = null;
          this.noQuestionsFound = true;
          this.noQuestonSubMessage = true;
          const dialogRef = this.dialog.open(DifficultyLevelComponent, {
            disableClose: true,
            data: {
              id: this.sdgId != "0" ? this.sdgId : this.questionParams.country,
              category: this.sdgId != "0" ? true : false,
              same_route: true,
            },
          });
          dialogRef.afterClosed().subscribe((data) => {
            if (data) {
              console.log(data);
              this.noQuestionsFound = true;
              let level = data === "HARD" ? 3 : 1;
              // this.router.navigate(['/question'], {
              //   relativeTo: this.activatedRoute,
              //   queryParams: { id : this.sdgId != '0' ? this.sdgId : '0',
              //     back: true,
              //     country : this.sdgId == '0' ? this.questionParams.country : '0',
              //     level },
              //   queryParamsHandling: null // Merges with the existing query parameters
              // });
              this.router.navigate(["/question"], {
                queryParams: {
                  id: this.sdgId,
                  back: true,
                  country: this.questionParams.country,
                  level,
                },
                skipLocationChange: false,
              });
              // this.getQuestionStatus();
            }
          });
        }
        if (
          status.data.completed_dfficulty.easy == true &&
          status.data.completed_dfficulty.hard == true
        ) {
          console.log(
            this.sdgId,
            this.selectedCountry,
            this.questionParams.country
          );

          let params = {
            id: this.sdgId != "0" ? this.sdgId : this.questionParams.country,
            category: this.sdgId != "0" ? true : false,
          };
          this.router.navigate(["/topic-completed"], { queryParams: params });
        }
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
      },
    });
    if (this.unAttendedQuestions.length == 0) {
      // this.dialogRef.close("completed");
      // if (this.data.difficulty != '') {
      //   this.dialogRef.close();
      // } else {
      //   this.dialogRef.close("completed");
      // }
    } else {
      // this.correctAnswer = false;
      // this.showQuestion = true;
      console.log("continue to next");
      this.getQuestion(this.questionId);
    }
  }

  skipToNextQuestion() {
    this.selectedOption = "";
    this.unAttendedQuestions.every((qstn: any, index) => {
      if (qstn.id == this.questionId) {
        // console.log(index, this.unAttendedQuestions.length - 1)
        if (index == this.unAttendedQuestions.length - 1) {
          console.log("last");
          this.getQuestion(this.unAttendedQuestions[0].id);
          return false;
        } else {
          this.getQuestion(this.unAttendedQuestions[index + 1].id);
          this.repopulateQuestionList(index);
          return false;
        }
      } else {
        return true;
      }
    });
  }

  countryChange(event: any) {
    this.questionParams.country = event?.id;
    this.router.navigate(["/question"], {
      queryParams: {
        id: 0,
        back: true,
        country: event?.id,
        level: this.difficultyLevel,
      },
    });
  }

  subjectChange(item: any) {
    this.questionParams.category = item?.id;
    this.router.navigate(["/question"], {
      queryParams: {
        id: item?.id,
        back: true,
        country: "",
        level: this.difficultyLevel,
      },
    });
  }

  confirmQuit(questionCompleted: boolean = false) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      disableClose: true,
      data: { questionCompleted },
    });
    dialogRef.afterClosed().subscribe((data: boolean) => {
      if (data) {
        this.router.navigateByUrl("/map-view");
      }
    });
  }

  playVideo() {
    // console.log(this.questionDetails.video_link);
    // let id = this.questionDetails.video_link.split('/').pop().split(' ')
    // let videoLink = "https://www.youtube.com/embed/"+id[0];
    let videoLink =
      this.selectedLang == "en_us"
        ? this.questionDetails?.video_link_en_us
        : this.questionDetails?.video_link_nl;
    this.dialog.open(ShowMovieComponent, {
      disableClose: true,
      width: "800px",
      height: "auto",
      data: { movie: videoLink, quizVideo: true },
    });
  }

  showImage() {
    let imageLink =
      this.selectedLang == "en_us"
        ? this.questionDetails?.image_en_us
        : this.questionDetails?.image_nl;
    console.log(imageLink);
    this.dialog.open(ImageModalComponent, {
      disableClose: true,
      data: { image: imageLink },
    });
  }

  //feedbacks are shown when selected option is right
  //Hints are shown when selected option is wrong
  getFeedbackOrHint() {
    if (this.questionDetails?.correct_option == this.selectedOption?.id) {
      return this.questionDetails?.feedback
        ? this.getTranslation(this.questionDetails, "feedback")
        : "";
    } else {
      return this.questionDetails?.hint
        ? this.getTranslation(this.questionDetails, "hint")
        : "";
    }
  }
}
